import type { SVGProps } from "react";

// 生成物（scripts/gen-brand-icons.mjs）。直接編集せず、幾何・配色はスクリプト側を変えて再生成する。
// TST ブランドマーク: 頭文字 "TST"（パスで描いた文字。フォント非依存）。
// public/ の favicon / アプリアイコン（先方サイト由来の赤い富士山）とは別の絵柄。

type Props = SVGProps<SVGSVGElement>;

/** 単色マーク（currentColor 追従）。ヘッダやログインカードで文字と並べる用途。 */
export function BrandMark(props: Props) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={24}
      height={24}
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path d="M7.75 20 H22.25 V25 H17.5 V44 H12.5 V25 H7.75 Z" />
      <path d="M39.25 27.25 A7.25 7.25 0 1 0 32 34.5 A2.25 2.25 0 1 1 29.75 36.75 L24.75 36.75 A7.25 7.25 0 1 0 32 29.5 A2.25 2.25 0 1 1 34.25 27.25 Z" />
      <path d="M41.75 20 H56.25 V25 H51.5 V44 H46.5 V25 H41.75 Z" />
    </svg>
  );
}

/** アプリタイル（背景色付き・角丸）。スプラッシュなど単独で置く用途。 */
export function BrandTile(props: Props) {
  return (
    <svg viewBox="0 0 64 64" width={48} height={48} aria-hidden="true" {...props}>
      <rect width="64" height="64" rx="14" fill="#0e1117" />
      <g fill="#ffffff">
        <path d="M7.75 20 H22.25 V25 H17.5 V44 H12.5 V25 H7.75 Z" />
        <path d="M39.25 27.25 A7.25 7.25 0 1 0 32 34.5 A2.25 2.25 0 1 1 29.75 36.75 L24.75 36.75 A7.25 7.25 0 1 0 32 29.5 A2.25 2.25 0 1 1 34.25 27.25 Z" />
        <path d="M41.75 20 H56.25 V25 H51.5 V44 H46.5 V25 H41.75 Z" />
      </g>
    </svg>
  );
}

/** 非 React の HTML 文字列へ埋め込む単色マーク（印刷用領収書など）。 */
export function brandMarkSvg(color: string, size = 16): string {
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="${size}" height="${size}" fill="${color}" aria-hidden="true">` +
    '<path d="M7.75 20 H22.25 V25 H17.5 V44 H12.5 V25 H7.75 Z"/><path d="M39.25 27.25 A7.25 7.25 0 1 0 32 34.5 A2.25 2.25 0 1 1 29.75 36.75 L24.75 36.75 A7.25 7.25 0 1 0 32 29.5 A2.25 2.25 0 1 1 34.25 27.25 Z"/><path d="M41.75 20 H56.25 V25 H51.5 V44 H46.5 V25 H41.75 Z"/>' +
    "</svg>"
  );
}
